import { render } from "./ForgotPasswordInput.vue?vue&type=template&id=b2296bde"
import script from "./ForgotPasswordInput.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordInput.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__